import { render, staticRenderFns } from "./GenerateTkModal.vue?vue&type=template&id=219bfde2&scoped=true&"
import script from "./GenerateTkModal.vue?vue&type=script&lang=ts&"
export * from "./GenerateTkModal.vue?vue&type=script&lang=ts&"
import style0 from "./GenerateTkModal.vue?vue&type=style&index=0&id=219bfde2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "219bfde2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
